import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getVoucherList = async (param) => {
  const baseUrl = `${API_CONSTANTS.VOUCHER}/list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const getUnassignedVoucherPool = async ({
  mallId,
  tierId,
  campaignId,
  page = 1,
  limit = 50,
}) => {
  const baseUrl = `${API_CONSTANTS.GAMIFICATION}/vouchers`;
  // Quick task 260820-gyo (H7): campaignId is still sent in edit mode and the
  // backend still accepts it, but it no longer widens anything — the
  // exclusivity rule it used to work around (260805-go7) is gone. The
  // endpoint now returns every gamification voucher with STOCK remaining for
  // the mall/tier regardless of who else holds it, each row carrying
  // `remaining` (its real global remaining count) and `sharedWith` (the
  // other campaigns already attached to it). campaignId is kept purely for
  // contract compatibility — fetchData drops null/undefined params, so
  // create mode simply omits it.
  let responseObj = await fetchData(baseUrl, {
    mallId,
    tierId,
    campaignId,
    page,
    limit,
  });
  return responseObj;
};
export const addVoucher = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.post(
    `${API_CONSTANTS.VOUCHER}/add`,
    payload
  );

  return responseObj;
};

export const exportVouchers = async (params) => {
  const baseUrl = `${API_CONSTANTS.VOUCHER}/export`;
  return await fetchData(baseUrl, params);
};

export const deleteVoucher = async (id) => {
  let url = `${API_CONSTANTS.VOUCHER}/delete?id=${id}`;

  let responseObj = await dataAccess.del(url);
  return responseObj;
};

export const updateVoucher = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.VOUCHER}/update?id=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.put(url, payload);
  return responseObj;
};

export const complimentaryVoucher = async (
  voucherId,
  phone,
  status,
  serialNumber
) => {
  const url = `${API_CONSTANTS.VOUCHER}/complimentary-voucher?voucherId=${voucherId}&phone=${encodeURIComponent(phone)}&serialNumber=${encodeURIComponent(serialNumber)}&status=${status}`;
  const responseObj = await dataAccess.post(url);
  return responseObj;
};

export const bulkVoucherCancel = async (vouchers) => {
  const url = `${API_CONSTANTS.VOUCHER}/bulk-voucher-cancel`;
  const responseObj = await dataAccess.put(url, { data: { vouchers } });
  return responseObj;
};

export const getVoucherById = async (id) => {
  let url = `${API_CONSTANTS.VOUCHER}/detail?id=${id}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export async function uplaodBannerMedia(file) {
  let formData = new FormData();
  formData.append('image', file);
  let payload = {
    data: formData,
  };

  let responseObj = await dataAccess.upload(
    `${API_CONSTANTS.MEDIA_UPLOAD}`,
    payload
  );

  return responseObj;
}

//------------Voucher Banner---------------------------------------------------------------------------

export const createVoucherBanner = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.post(
    `${API_CONSTANTS.CREATE_VOUCHER_BANNER}/add`,
    payload
  );

  return responseObj;
};
export const updateVoucherBanner = async (incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.CREATE_VOUCHER_BANNER}/update`;

  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.put(url, payload);
  return responseObj;
};

export const getVoucherBannerById = async (id) => {
  let url = `${API_CONSTANTS.CREATE_VOUCHER_BANNER}/detail?bannerId=${id}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export const deleteVoucherBanner = async (id) => {
  let url = `${API_CONSTANTS.CREATE_VOUCHER_BANNER}/delete?bannerId=${id}`;

  let responseObj = await dataAccess.del(url);
  return responseObj;
};

export const changeVoucherBannerOrder = async (incomingData) => {
  let payload = {
    data: incomingData,
  };

  let url = `${API_CONSTANTS.CREATE_VOUCHER_BANNER}/sequence`;
  return await dataAccess.put(url, payload);
};

export const getVoucherTermsAndConditionsList = async (param) => {
  const baseUrl = `${API_CONSTANTS.VOUCHER}/voucher-terms-conditions`;
  let responseObj = await dataAccess.get(baseUrl);
  return responseObj;
};

export const reserveCustomerVoucher = async (voucherId, customerId) => {
  let url = `${API_CONSTANTS.VOUCHER}/reserve?voucherId=${voucherId}&customerId=${customerId}`;
  let response = await dataAccess.put(url);
  return response;
};
export const cancelCustomerVoucher = async (voucherId, customerId) => {
  let url = `${API_CONSTANTS.VOUCHER}/cancel?voucherId=${voucherId}&customerId=${customerId}`;
  let response = await dataAccess.put(url);
  return response;
};

export const getVouchersByPhone = async (phone) => {
  let responseObj = await dataAccess.get(
    `${API_CONSTANTS.CUSTOMER}/voucher-details?phone=${phone}&page=1&limit=1`
  );
  return responseObj;
};
